import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M1.5,11 L1.5,21.5 C1.5,22.6 2.4,23.5 3.5,23.5 L22.5,23.5 L22.5,11"/>
          <path d="M5,13 L12,18.5 L19,13 M22,9 L12,2 L2,9"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M2.5,21 L2.5,42.5 C2.5,43.6 3.4,44.5 4.5,44.5 L45.5,44.5 L45.5,21"/>
        <path d="M7,22 L24,35 L41,22 M45,18 L24,3.5 L3,18"/>
      </g>
    </svg>
  );
};
